import { MilestoneStatus, ToggleStyle } from '@/constants';
import store from '@/store';
import { HomeSummary, JobProgress, PricingBreakdown } from '@/types';
import { getRememberMe } from '@/util';

export const getMileStoneToggleStyle = (value: string) => {
  if (value.toLowerCase().trim() in ToggleStyle) {
    const enumVal: ToggleStyle = (ToggleStyle as any)[value.toLowerCase().trim()];
    return enumVal;
  } else {
    return 'hidden';
  }
}
export const getAreaCode = (user: any) => {
  const selectedJob = getRememberMe();
  let jobArea = '';
  user.jobs.forEach((element: any) => {
    if (element.jobNumber === selectedJob) {
      jobArea = element.areaId;
    }
  });
  return jobArea || '';
}

export const jobOwnershipStatus = () => {
  return store.getters.jobOwnershipStatus;
}

export const mostRecentMilestone = (phases: JobProgress): string => {
  let mostRecentField = '';
  for (const [key, milestone] of Object.entries(phases.mileStones)) {
    if (milestone.status.stage === MilestoneStatus.IN_PROGRESS) {
      mostRecentField = key;
    }
  }
  return mostRecentField;
}
export const appendCharacter = (data: string, character = '.') =>
  data.lastIndexOf(character) !== data.length - 1
    ? data + character
    : data;

export const getPricingBreakdown = (homeDetail: HomeSummary): PricingBreakdown => {
  return {
    basePrice: homeDetail.basePrice,
    optionsPrice: homeDetail.optionsPrice,
    selectionsTotalPrice: homeDetail.selectionsTotalPrice,
    contractAddendumTotalPrice: homeDetail.contractAddendumTotalPrice,
    changeRequestsTotalPrice: homeDetail.changeRequestsTotalPrice,
    runningTotalPrice: homeDetail.runningTotalPrice
  }
}
/* eslint-disable @typescript-eslint/camelcase */
export const BuildStageDates = {
  Build_PreConstructionMeeting: 'preConstructionMeetingDate',
  Build_HomeConstructionBegins: 'homeConstructionStartDate',
  Build_Foundation: 'foundationEndDate',
  Build_Framing: 'framingEndDate',
  Build_RoughMechanics: 'roughMechanicsEndDate',
  Build_PreDrywallReview: 'preDrywallReviewEndDate',
  Build_Drywall: 'drywallEndDate',
  Build_MidpointSurvey: 'contractSignedDate',
  Build_InteriorFinishes: 'interiorFinishesEndDate',
  Build_Final: 'finalPhaseEndDate'
};

export const OwnStageDates = {
  Own_HomeownerOrientation: 'orientationDate',
  Own_Closing: 'projectedCloseDate',
  Own_ThirtyDaysSurvey: 'projectedCloseDate',
  Own_SixtyDaysSurevey: 'customerCare60DayCompletionDate',
  Own_TwelveMonthSurvey: 'projectedCloseDate'
};
/* eslint-enable @typescript-eslint/camelcase */
